module.exports = __webpack_public_path__ + "img/laurencecarre.761814c5.jpeg";